import { setContext } from '@apollo/client/link/context';
import * as Sentry from '@sentry/react';

export const traceparentLink = setContext((_, { headers }) => {
  const span = Sentry.getCurrentHub().getScope().getSpan();

  if (!span) {
    return {};
  }

  const traceId = span.traceId;
  const spanId = span.spanId;

  return {
    headers: {
      ...headers,
      // sentry's traceparent is not compatible with the w3c standard
      traceparent: `00-${traceId}-${spanId}-01`,
    },
  };
});
